// extracted by mini-css-extract-plugin
export default {"container":"LanguageToggle_container__8PoQ5","langName":"LanguageToggle_langName__hhw7L"};